import React from 'react';

const AsyncAVMonitoringList = React.lazy(() => import('./ListContainer'));

export const AVMonitoringList = () => {
  return <AsyncAVMonitoringList />;
};
